import { render, staticRenderFns } from "./CashbookMobile.vue?vue&type=template&id=160b8696&"
import script from "./CashbookMobile.vue?vue&type=script&lang=ts&"
export * from "./CashbookMobile.vue?vue&type=script&lang=ts&"
import style0 from "./CashbookMobile.vue?vue&type=style&index=0&id=160b8696&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports